
import Ram2 from "../../../assets/duotone/Ram2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Ram2Icon({ className, dataTestid = "Ram2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Ram2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
